import {StorageServiceBase} from "../storage-service-base";
import {RawSessionStorageKeys} from "./raw-session-storage-keys";
import {IRawSessionStorageService} from "./raw-session-storage.service.interface";
import {UndefinedString} from "../../../types/nullable-types";
import {IServiceFactory} from "../../service-factory.interface";

export class RawSessionStorageService extends StorageServiceBase<RawSessionStorageKeys> implements IRawSessionStorageService{
    constructor(services: IServiceFactory) {
        super(sessionStorage, services);
    }

    protected get _storageName(): string {
        return "rawSessionStorage";
    }

    protected _composeKey(key: RawSessionStorageKeys, discriminator: UndefinedString): string {
        if(discriminator) {
            return `${key}.${discriminator}`;
        } else {
            return key;
        }
    }

    protected _clearLargeStorageConsumersData() {
        this.services.largeStorageConsumersManager.clearSessionStorageConsumers();
    }
}